// import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { createNestablePublicClientApplication, LogLevel } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: "697ca22d-4fd3-48a9-9747-20cfa5798331", // MeetingRoomMap
    },
    cache: {
        cacheLocation: "localStorage", // or "sessionStorage"
        storeAuthStateInCookie: false, // Set to true if you have issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: false,
        },
    },
};

const useAccessToken = () => {
    const [accessToken, setAccessToken] = useState(null);

    useEffect(() => {
        Office.onReady(async (info) => {
            if (info.host === Office.HostType.Outlook) {
                console.log("useAccessToken - Ready to get accessToken");
                const msalInstance = await createNestablePublicClientApplication(msalConfig);
                console.dir(msalInstance);

                let at = null;

                const getAccessToken = async () => {
                    const tokenRequest = {
                        // scopes: ["openid", "profile", "User.Read"]
                        //scopes: ["Calendars.Read", "email", "MailboxSettings.Read", "openid", "offline_access", "profile", "User.Read", "Place.Read.All", "User.Read.All", "api://www.meetingroommap.net/697ca22d-4fd3-48a9-9747-20cfa5798331/access_as_user"],
                        scopes: ["api://www.meetingroommap.net/697ca22d-4fd3-48a9-9747-20cfa5798331/access_as_user"],
                        
                    };

                    // 1: Call acquireTokenSilent.
                    try {
                        console.log("Trying to acquire token silently...");
                        const userAccount = await msalInstance.acquireTokenSilent(tokenRequest);
                        console.log("Acquired token silently.");
                        at = userAccount.accessToken;
                    } catch (error) {
                        console.log(`Unable to acquire token silently: ${error}`);
                    }

                    // 2: Call acquireTokenPopup.
                    if (at === null) {
                        // Acquire token silent failure. Send an interactive request via popup.
                        try {
                            console.log("Trying to acquire token interactively...");
                            const userAccount = await msalInstance.acquireTokenPopup(tokenRequest);
                            console.log("Acquired token interactively.");
                            at = userAccount.accessToken;
                        } catch (popupError) {
                            // Acquire token interactive failure.
                            console.log(`Unable to acquire token interactively: ${popupError}`);
                        }
                    }

                    // Log error if both silent and popup requests failed.
                    if (at === null) {
                        console.error(`Unable to acquire access token.`);
                        return;
                    }

                    console.log('############### AT');
                    console.log(at);

                    setAccessToken(at);
                };

                getAccessToken();
            }
        });
    }, []);


    return accessToken;
};

export default useAccessToken;